import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import SignIn from './User/SignIn'
import Register from './User/Register'
import ForgetPassword from './User/ForgetPassword';
import OldMemberChangePassword from './User/OldMemberChangePassword'
import CrossIcon from './icon/Cross'
import isEmail from './dev/validation/isEmail';
import withLoginCheck from './HOC/withLoginCheck'
const { REACT_APP_URI = '/' } = process.env

class User extends Component {
    state = {
    }
    componentDidMount() {
        fetch(`${REACT_APP_URI}/accounts/getToken/`, { credentials: 'include' })
            .then(res => res.json())
            .then(res => this.props.dispatch({ type: 'setToken', token: res.token}))
        
    }
    render() {
        const { isActive, condition } = this.props.user
        return (
            <React.Fragment>
                <Mask 
                    isActive={isActive} 
                    onClick={() => { if(condition === 'signIn'){ this.props.dispatch({ type: 'toggleUserField' })}}}>
                </Mask>
                <Container isActive={isActive} isSignIn={condition === 'signIn'}>
                    <Content isRegister={condition === 'register'}>
                        <Delete onClick={() => this.props.dispatch({ type: 'toggleUserField' })}>
                            <CrossIcon />
                        </Delete>
                        {condition === 'signIn' && <SignIn isEmail={isEmail}/>}
                        {condition === 'register' && <Register />}
                        {condition === 'forgetPassword' && <ForgetPassword />}
                        {condition === 'oldMemberChangePassword' && <OldMemberChangePassword />}
                    </Content>
                </Container>
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User
    }
}
export default connect(mapStateToProps)(withLoginCheck(User));

const Mask = styled.div`
    position: fixed;
    visibility: ${props => props.isActive ? 'visible' : 'hidden'};
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 50000;
    transition: all .2s ease-in-out;
    background-color: rgba(0,0,0,.6);
    overflow: hidden;
    /* filter blur 效果設在 Background component中 */
`
const Container = styled.div`
    position: fixed;
    visibility: ${props => props.isActive ? 'visible' : 'hidden'};
    opacity: ${props => props.isActive ? '1' : '0'};
    width: 350px;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
    transition: all .2s ease-in-out;
    background-color: #fff;
    z-index: 50001;
`
const Content = styled.div`
    position: relative;
    width: 100%;
    min-height: ${props => props.isRegister? '420px' : '380px'};
    padding: 48px;
`
const Delete = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    top: 12px;
    right: 12px;
    cursor: pointer;
    &:hover {
        svg path {
            fill: #de0606;
        }
    }
`


// WEBPACK FOOTER //
// ./src/User.js